import PeopleLanguages from './PeopleLanguages';

export { type PeopleLanguagesProps } from './PeopleLanguages';
export default PeopleLanguages;
